module.exports = __webpack_public_path__ + "8ebac5e8845e7f4f931f3939104dc83a.svg";